import { render } from "./AdjustmentCreation.vue?vue&type=template&id=509c0e5c&scoped=true"
import script from "./AdjustmentCreation.vue?vue&type=script&lang=js"
export * from "./AdjustmentCreation.vue?vue&type=script&lang=js"

import "./AdjustmentCreation.vue?vue&type=style&index=0&id=509c0e5c&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509c0e5c"]])

export default __exports__